import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SIDEBARNAVIGATIONMODALITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "path",
  "link_target",
  "icon",
  "user_must_be_logged_in"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  sidebarNavigationModalItemBlockDescriptor: _generatedSidebarNavigationModalItemBlockDescriptor,
  sidebarNavigationModalItemBlockBlocDefinition,
  sidebarNavigationModalItemBlockDashboardLayout,
  sidebarNavigationModalItemBlockConfig,
  sidebarNavigationModalItemBlockResolveConfig,
  sidebarNavigationModalItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Sidebar navigation modal item",
    componentType: 'SidebarNavigationModalItemBlockComponent',
    category: 'navigation',
    description: "Sidebar navigation modal item.",
    keywords: [],
    allowedIn: [
      { bloc: "SidebarNavigationModalComponent", slot: "custom_items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        "label": "Title"
      }
    }),
    path: propertyValue({
      type: 'link',
      value: '',
      options: {
        "label": "Link"
      }
    }),
    link_target: propertyValue({
      type: 'select',
      value: "self",
      options: {
        "label": "Link target",
        "help": "Only for external link",
        "choices": [
          {
            "value": "_self",
            "label": "Current tab"
          },
          {
            "value": "_blank",
            "label": "New tab"
          }
        ]
      }
    }),
    icon: propertyValue({
      type: 'text',
      value: '',
      options: {
        "label": "Icon"
      }
    }),
    user_must_be_logged_in: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        "label": "Display only if user is logged in"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["title", "path", "link_target", "icon", "user_must_be_logged_in"],
          },
        ],
      },
    ],
  })
);

export function sidebarNavigationModalItemBlockDescriptor(): IBlockDescriptor;
export function sidebarNavigationModalItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function sidebarNavigationModalItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSidebarNavigationModalItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSidebarNavigationModalItemBlockDescriptor, sidebarNavigationModalItemBlockProperties, fieldOrder);
}

export {
  sidebarNavigationModalItemBlockBlocDefinition,
  sidebarNavigationModalItemBlockDashboardLayout,
  sidebarNavigationModalItemBlockProperties,
  sidebarNavigationModalItemBlockConfig,
  sidebarNavigationModalItemBlockResolveConfig,
};

export type SidebarNavigationModalItemBlockConfig = typeof sidebarNavigationModalItemBlockConfig;
